import { render, staticRenderFns } from "./EndStation.vue?vue&type=template&id=05872f30&scoped=true&"
import script from "./EndStation.vue?vue&type=script&lang=js&"
export * from "./EndStation.vue?vue&type=script&lang=js&"
import style0 from "./EndStation.vue?vue&type=style&index=0&id=05872f30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05872f30",
  null
  
)

export default component.exports